import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { useStyles } from './styles';
import { setAPIError } from 'redux/actions';

const ErrorModal = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);

  const [showModal, setShowModal] = useState(false);

  const { isAPIError } = user;

  useEffect(() => {
    if (isAPIError) {
      setShowModal(true);
    }
  }, [isAPIError]);

  const handleClose = () => {
    setShowModal(false);
    dispatch(setAPIError(false));
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="error-modal-description"
      aria-describedby="error-modal-description"
      PaperProps={{ className: classes.modal }}
    >
      <DialogContent className={classes.modalContent} data-testid="error_modal">
        <Typography id="error-modal-description" variant="body2" color="textSecondary">
          {t('error_contacting_server', 'Error contacting server. Please try again')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus variant="outlined">
          {t('ok', 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
